import { AfterViewInit, Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ShapeCreatorService } from '../services/shape-creator.service';
import { ConfigService } from '../services/config.service';
import { AnimatorService } from '../services/animator.service';
import { CommunicationService } from "../services/communication.service";
import { ControllerService } from "../services/controller.service";


declare var BABYLON;
declare var window;
var debug = false;
var _console = {
  "log": (...args) => {
    if (debug) {
      window.console.log(...args)
    }
  }
}
@Component({
  selector: 'app-iengine',
  templateUrl: './iengine.component.html',
  styleUrls: ['./iengine.component.scss']
})

export class IengineComponent implements OnInit, AfterViewInit {
  @ViewChild('datauxview', { static: true }) public datauxview: any;
  @ViewChild('positiontoolcomponent', { static: true }) public positiontoolcomponent: any;

  shapeCreatorService: ShapeCreatorService;
  dfx: any;
  scene: any;
  debug_ag: any = [];
  land_mtl: any;
  shipCompsCntls: any = [];
  bckupShip_comp_ctl_list: string;
  compDefPos: any = [];
  shipComps: any = [];
  shipElems: any[];
  dbobj: any = [];
  children: any = [];
  sensors: any = [];
  cameras: any = [];
  dbchildobj: any = [];
  dragMode: any = false;
  showSSPanel: boolean = true;
  broadcastSubs: any;
  mesh_explode: boolean = false;
  explosion: any;
  explosion_cm: any;
  targetClicked: boolean;
  viewMode = 'solid';
  viewObjectMode = 'solid';
  pickElement: any = false;
  selectedelem: string;
  sensorTargetOff: any = false;
  cameraTargetOff = false;
  compTargetOff = false;
  comp_target_arr: any = [];
  compTargets: any = [];
  disableTrans: boolean = false;
  shipSmartSensor: any = [];
  selectedLabel: string;
  transMode: boolean = true;
  tagStatus: any = false;
  objDrillDownDataPath: any = [];
  shipCameras: any = [];
  globalPause: any;
  animStatus: string = "stopped";
  pauseAnim = false;
  compAnimStatus: string = "playing"
  focus_title: any;
  focus_col: any;
  focusMode: boolean = false;
  showLoading: boolean = true;
  pickEvent: boolean = false;
  styleLength: any = '';
  testMode: any;
  constructor(private ctrlServ: ControllerService, private configService: ConfigService, private animatorService: AnimatorService, private communicationServ: CommunicationService) {
    this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: "", event: 'showBlockLoading' } });
  }

  ngOnInit(): void {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "controls") {
          if (data.event === 'explode') {
            if (data["key"] === false) {
              this.mesh_explode = false;
              this.resetMeshExplode();
              return
            }
            this.mesh_explode = true;
            //this.selectedLabel = null;
            //this.toggleOffOcean(false);
            this.explodeMesh(data['data']);
            this.showHideLand(false);
          }
        }
        if (data.src === 'sidepanel') {
          if (data.event === "iengine-controlChange") {
            let obj = data['data'];
            this.onControlChange(obj)
          }
          if (data.event === "engineAnim") {
            if (data.key) {
              // this.engineAnimationMode = data.key;
              this.startEngineAnim();
              setTimeout(() => {
                this.onChangeCameraPosition('home');
              }, 500);

            } else {
              // this.engineAnimationMode = data.key;
              this.stopEngineAnim();
            }
          }
          if (data.event === 'hide-root-component') {
            this.showEngineModel(false);
          }
        }

      })
  }

  showHideTransElem(state) {
    if (state) {
      this.hideTransparentElem()
    } else {
      this.showTransparentElem();
    }
  }

  showTransparentElem() {
    this.transMode = true;
    let dfx = this.getDatascape();
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((info) => {

        if (info.opacity === 'transparent' || !info.selected) {
          if (this.multipleTagStatus) {
            _console.log("multipleTagStatus", info)
            var elem = this.datauxview.getElementId(info.id)
            this.addObserver(elem);
          } else {
            if (this.selectedelem) {
              this.addObserver(elem);
            }
          }
          info.opacity = 'transparent';
          this.showHideElem(info.id, true);
          info.visible = true;

          if (info && info.sensors) {
            info.sensors.forEach((sensor) => {
              let profile = 'regular';
              let elem = this.datauxview.getElementId(sensor);
              let isSensorT = this.sensors.includes(sensor) && sensor.includes('target');
              let isCameraT = this.cameras.includes(sensor) && sensor.includes('target');
              if (isSensorT && this.sensorTargetOff) {
                profile = 'invisible'
              }
              if (isCameraT && this.cameraTargetOff) {
                profile = 'invisible'
              }
              if (elem) {
                dfx.modify(elem, { profile });
              }
            })
          }
        }
      })
    }
  }

  hideTransparentElem() {
    this.transMode = false;
    let dfx = this.getDatascape();
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((info) => {
        if (info.opacity === 'transparent' || !info.selected) {
          if (this.multipleTagStatus) {
            _console.log("multipleTagStatus", info)
            var elem = this.datauxview.getElementId(info.id)
            this.removeObserver(elem);
            let pop = document.getElementById('tooltip_' + info.id);
            pop.style.display = "none";
            //this.addObserver(elem);
            //this.selectedelem = elem;
          } else {
            if (this.selectedelem) {
              this.removeObserver(elem);
              let pop = document.getElementById('tooltip_' + info.id);
              pop.style.display = "none";
            }
          }

          this.showHideElem(info.id, false);
          info.visible = false;

          if (info && info.sensors) {
            info.sensors.forEach((sensor) => {
              let profile = 'invisible';
              let elem = this.datauxview.getElementId(sensor);
              /* let isSensor=this.sensors.includes(sensor);
              let isCamera = this.cameras.includes(sensor);
              if(isSensor&&this.sensorTargetOff){
                profile='invisible'
              }
              if(isCamera&&this.cameraTargetOff){
                profile='invisible'
              } */
              if (elem) {
                dfx.modify(elem, { profile });
              }
            })
          }
        }
      })
    }
  }
  broadcastInfo(data: any) {
    this.communicationServ.getInstance().next(data);
  }

  /**
  * sample code to load the application venue using different data source
  */
  ngAfterViewInit(): void {
    // load all the canvas settings from settings json file     
    this.configService.loadFile('../assets/license.info').then((info) => {
      this.configService.getProjectConfig().then((project_config: any) => {
        project_config.licence = info;
        this.datauxview.setProjectSettins(project_config);
        this.datauxview.loadCanvas('settings-iengine', 'json', (data, settingstatus) => {
          var setting_status = settingstatus;
          this.datauxview.yaw_3d = this.datauxview.yaw_2d = 270;
          this.datauxview.pitch_2d = 15
          if (!setting_status) {
            setting_status = this.attachDynamicObject(data, (settingstatus) => {
              if (settingstatus) {
                this.initObjects();
              }
            });
          } else {
            this.initObjects();
          }
          setTimeout(() => {
            this.pickleftAttach();
            this.styleLength = document.head.getElementsByTagName('style').length;
          }, 2000);
        });

      }, (err) => { _console.log(err) });
    }, (err) => { alert("License not found!") });
  }

  track_label_tex = {
    "meshes": [{
      "position": [0, 0, 0],
      "rotation": [0, 0, 0],
      "scaling": [1, 1, 1],
      "isVisible": true,
      "isEnabled": true,
      "checkCollisions": false,
      "alphaIndex": 201,
      "billboardMode": 0,
      "receiveShadows": false,
      "name": "track",
      "id": "track",
      "positions": [],
      "normals": [],
      "uvs": [],
      "indices": []
    }]
  };
  attachDynamicObject(data, callback) {
    var _this = this;
    const TERMINAL_ORIGIN = [-97.35, 33];
    this.shapeCreatorService = new ShapeCreatorService(TERMINAL_ORIGIN[0], TERMINAL_ORIGIN[1]);
    var trackWidth_met = 4;
    let trackgeom = _this.shapeCreatorService.MakeColourRect(1000, trackWidth_met, 32.0 / 1024.0, 1 - (828.0 / 1024.0));
    let _track = JSON.parse(JSON.stringify(_this.track_label_tex));
    let track = _track.meshes[0];
    track.name = track.name;
    track.id = track.name;
    track.positions = trackgeom.positions;
    track.normals = trackgeom.normals;
    track.uvs = trackgeom.uvs;
    track.indices = trackgeom.indices;
    data.shapes[track.name] = 'data:' + JSON.stringify(_track);
    return _this.datauxview.attachDynamicObject(data, callback);
  }

  /* * *
  * method for init objects
  * * */
  initObjects() {
    window.scope = this;
    // load all the assets to be used information from socket
    this.datauxview.loadAssets('objects-iengine', 'json', (objectstatus) => {
      if (objectstatus) {
        this.datauxview.renderAssets('objects-iengine', 'json', (objectstatus) => {
          if (objectstatus) {
            this.dfx = this.datauxview.getDatascape();
            this.scene = this.dfx.getCamera().getScene();
            this.initEngineAnim();
            this.ctrlServ.init(this.datauxview);
            this.addEnv();
            this.setShipCompsCntls();
            this.showEngineModel();
            this.showEngineAnimationModel(false);
            this.deconstructShip();
            this.initExplodeMesh();
            this.onChangeCameraPosition('home');
            this.showLoading = false;
            this.storeDefaultPosition();
            this.processModel();       
            this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: "", event: 'showBlockLoading' } });
          }
        }, () => { })
      }
    });
  }

  defCameraView = {};
  storeDefaultPosition() {
    let dfx = this.datauxview.getDatascape();
    let cameraProps = dfx.getCamera();
    let view = { "target": { "x": -1.1, "y": 10, "z": -30 }, "distance": 60, "yaw": 140, "pitch": 12 };
    view['target']['x'] = Number(cameraProps['targetX']['value'].toFixed(4));
    view['target']['y'] = Number(cameraProps['targetY']['value'].toFixed(4));
    view['target']['z'] = Number(cameraProps['targetZ']['value'].toFixed(4));
    view['distance'] = Number(cameraProps['distance']['value'].toFixed(4));
    view['yaw'] = Number(cameraProps['yaw_deg']['value'].toFixed(4));
    view['pitch'] = Number(cameraProps['pitch_deg']['value'].toFixed(4));
    this.defCameraView = view;
  }

  addEnv() {
    //this.setVenueLightIntensity(2.25);
    //this.sky = this.dfx.addSky('sky', { size: 30000, rayleigh: 1, inclination: 0.1 });
    let m = this.datauxview.getElementId("land");
    let mesh = this.dfx.getElementMesh(m);
    let glass_mtl = this.scene.getMaterialByID("glass_mtl");
    let glass_mtl2 = this.dfx.getStandardMaterial("glass_mtl2");
    let tex = glass_mtl.diffuseTexture;//dfx.getTexture("/assets/rov/assets/base.png");
    glass_mtl2.diffuseColor.r = 0.15;
    glass_mtl2.diffuseColor.g = 0.15;
    glass_mtl2.diffuseColor.b = 0.15;
    glass_mtl2.opacityTexture = tex;
    glass_mtl2.opacityTexture.getAlphaFromRGB = true;
    mesh.material = glass_mtl2;
    this.land_mtl = glass_mtl2;
    mesh.isPickable = false;
  }

  setShipCompsCntls() {
    this.shipCompsCntls["Components"] = [{ "name": "Bolts", "id": "Bolts", "children": [{ "name": "Bolts", "id": "Bolts", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Camshafts", "id": "Camshafts", "children": [{ "name": "Camshafts", "id": "Camshafts", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Connecting_Rod_lower_parts", "id": "Connecting_Rod_lower_parts", "children": [{ "name": "Connecting_Rod_lower_parts", "id": "Connecting_Rod_lower_parts", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Connecting_Rods", "id": "Connecting_Rods", "children": [{ "name": "Connecting_Rods", "id": "Connecting_Rods", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Crankshafts", "id": "Crankshafts", "children": [{ "name": "Crankshafts", "id": "Crankshafts", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Cylinderheads", "id": "Cylinderheads", "children": [{ "name": "Cylinderheads", "id": "Cylinderheads", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Engineblocks", "id": "Engineblocks", "children": [{ "name": "Engineblocks", "id": "Engineblocks", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Frontgears", "id": "Frontgears", "children": [{ "name": "Frontgears", "id": "Frontgears", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "FuelInjectors", "id": "FuelInjectors", "children": [{ "name": "FuelInjectors", "id": "FuelInjectors", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Gaskets", "id": "Gaskets", "children": [{ "name": "Gaskets", "id": "Gaskets", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "LubricationPaths", "id": "LubricationPaths", "children": [{ "name": "LubricationPaths", "id": "LubricationPaths", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Nuts", "id": "Nuts", "children": [{ "name": "Nuts", "id": "Nuts", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Oilpumps", "id": "Oilpumps", "children": [{ "name": "Oilpumps", "id": "Oilpumps", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "P_Rings_lower", "id": "P_Rings_lower", "children": [{ "name": "P_Rings_lower", "id": "P_Rings_lower", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "P_Rings_upper", "id": "P_Rings_upper", "children": [{ "name": "P_Rings_upper", "id": "P_Rings_upper", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Piston_conector_holders", "id": "Piston_conector_holders", "children": [{ "name": "Piston_conector_holders", "id": "Piston_conector_holders", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Piston_inside_conectors", "id": "Piston_inside_conectors", "children": [{ "name": "Piston_inside_conectors", "id": "Piston_inside_conectors", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Piston_rings", "id": "Piston_rings", "children": [{ "name": "Piston_rings", "id": "Piston_rings", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Pistons", "id": "Pistons", "children": [{ "name": "Pistons", "id": "Pistons", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Valves", "id": "Valves", "children": [{ "name": "Valves", "id": "Valves", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "ValveTrains", "id": "ValveTrains", "children": [{ "name": "ValveTrains", "id": "ValveTrains", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }]
    console.log("this.shipCompsCntls", this.shipCompsCntls);
    this.bckupShip_comp_ctl_list = JSON.stringify(this.shipCompsCntls);
    // this.broadcastInfo({ src: 'main', event: 'shipCompsCntls', data: this.shipCompsCntls });
  }

  deconstructShip() {
    //this.replaceMats();
    let dfx = this.datauxview.getDatascape();
    let ship = this.datauxview.getElementId('iengine');
    let mesh = dfx.getElementMesh(ship);
    mesh.getChildren().forEach((m) => {
      if (!m.isPickable) {
        m.isPickable = true;
      }
      let mid = this.getMeshID(m);
      this.shipComps.push(mid);
      let _rot = m.rotationQuaternion ? m.rotationQuaternion.toEulerAngles() : m.rotation;
      let _ce = this.getParentElemBound(m);
      this.compDefPos[mid] = { bound: _ce, color: m.material.albedoColor, position: { x: m.position.x, y: m.position.y, z: m.position.z }, rot: { x: _rot.x, y: _rot.y, z: _rot.z }, qrot: m.rotationQuaternion, scale: m.scaling }
      m.isVisible = false;
      m.setEnabled(false);
    })
    let children = [];
    this.shipComps.forEach((c) => {
      let comp = this.datauxview.getElementId(c);
      let geometry = this.compDefPos[c];
      dfx.modify(comp, { geometry: { position: geometry.position } })
      children.push(comp);
      let pos = { x: geometry.position.x, y: geometry.position.y, z: geometry.position.z };
      this.children[c] = { pos }
      let hmesh = dfx.getElementMesh(comp);
      hmesh.getChildMeshes().forEach(_m => {
        let mname = this.getMeshName(_m.name);
        let _pos = { x: _m.position.x, y: _m.position.y, z: _m.position.z };
        this.children[mname] = { pos : _pos}
      })
      if (!this.dbobj[c]) {
        this.dbobj[c] = [, hmesh];
      }
      hmesh.rotationQuaternion = null;
      hmesh.rotation.x = geometry.rot.x;
      hmesh.rotation.y = geometry.rot.y;
      hmesh.rotation.z = geometry.rot.z;
      hmesh.scaling = geometry.scale;
      /*  let nm = hmesh.material&&hmesh.material.name;
       if(this.mtls[nm]){
         hmesh.material=this.mtls[nm];
       } */
      dfx.setElementTransition(comp, 0);
    })
    dfx.setAsParent(ship, children);
    //dfx.setElementScale(ship, [40, 40, 40]);
    this.shipElems = [].concat(this.shipComps);
    mesh.isVisible = false;

    //this.deconstructChildShip(mesh);
    this.applyParentChild();
    // if (this.testMode == 'assemble-parts') {
    //   this.getQuestion();
    // }
    this.excludeRHIBLighting(mesh);
  }
  deconstructChildShip(pmesh) {
    pmesh.getChildren().forEach((m) => {
      let dfx = this.datauxview.getDatascape();
      let shipChildComps = [];
      m.getChildren().forEach((cmesh) => {
        if (!cmesh.isPickable) {
          cmesh.isPickable = true;
        }
        let cid = this.getMeshID(cmesh);
        let comp = this.datauxview.getElementId(cid);
        if (!comp) return;
        shipChildComps.push(cid);
        let _rot = cmesh.rotationQuaternion ? cmesh.rotationQuaternion.toEulerAngles() : cmesh.rotation;
        let _ce = this.getParentElemBound(cmesh);
        this.compDefPos[cid] = { bound: _ce, color: cmesh.material.albedoColor, position: { x: cmesh.position.x, y: cmesh.position.y, z: cmesh.position.z }, rot: { x: _rot.x, y: _rot.y, z: _rot.z }, qrot: cmesh.rotationQuaternion, scale: cmesh.scaling }
        cmesh.isVisible = false;
        cmesh.setEnabled(false);
      })

      let children = [];
      shipChildComps.forEach((c) => {
        let comp = this.datauxview.getElementId(c);
        if (!comp) return;
        let geometry = this.compDefPos[c];
        dfx.modify(comp, { geometry: { position: geometry.position } })
        children.push(comp);
        let pos = { x: geometry.position.x, y: geometry.position.y, z: geometry.position.z };
        this.children[c] = { pos }
        let hmesh = dfx.getElementMesh(comp);
        if (!this.dbchildobj[c]) {
          this.dbchildobj[c] = [, hmesh];
        }
        hmesh.rotationQuaternion = null;
        hmesh.rotation.x = geometry.rot.x;
        hmesh.rotation.y = geometry.rot.y;
        hmesh.rotation.z = geometry.rot.z;
        hmesh.scaling = geometry.scale;
        dfx.setElementTransition(comp, 0);
      });
    });
    this.deconstructThirdLevelShip(pmesh);
  }


  deconstructThirdLevelShip(pmesh) {
    let shipChildComps = [];
    let dfx = this.datauxview.getDatascape();
    pmesh.getChildren().forEach((cmesh) => {
      cmesh.getChildren().forEach((mesh) => {
        mesh.getChildren().forEach((m) => {
          if (!m.isPickable) {
            m.isPickable = true;
          }
          let cid = this.getMeshID(m);
          let comp = this.datauxview.getElementId(cid);
          if (!comp) return;
          shipChildComps.push(cid);
          let _rot = m.rotationQuaternion ? m.rotationQuaternion.toEulerAngles() : m.rotation;
          let _ce = this.getParentElemBound(m);

          this.compDefPos[cid] = { bound: _ce, color: m.material.albedoColor, position: { x: m.position.x, y: m.position.y, z: m.position.z }, rot: { x: _rot.x, y: _rot.y, z: _rot.z }, qrot: m.rotationQuaternion, scale: m.scaling }
          m.isVisible = false;
          m.setEnabled(false);
        })

        let children = [];
        shipChildComps.forEach((c) => {
          let comp = this.datauxview.getElementId(c);
          if (!comp) return;
          let geometry = this.compDefPos[c];
          dfx.modify(comp, { geometry: { position: geometry.position } })
          children.push(comp);
          let pos = { x: geometry.position.x, y: geometry.position.y, z: geometry.position.z };
          this.children[c] = { pos }
          let hmesh = dfx.getElementMesh(comp);
          if (!this.dbchildobj[c]) {
            this.dbchildobj[c] = [, hmesh];
          }
          hmesh.rotationQuaternion = null;
          hmesh.rotation.x = geometry.rot.x;
          hmesh.rotation.y = geometry.rot.y;
          hmesh.rotation.z = geometry.rot.z;
          hmesh.scaling = geometry.scale;
          dfx.setElementTransition(comp, 0);
        });
      });
    });
  }


  excludeRHIBLighting(mesh) {
    let lights = this.scene.lights;
    lights.forEach((light) => {
      //light.excludedMeshes.push(mesh);
      this.applyExlude(light, mesh);
    })
  }

  moveCameraTo(el, view = null) {
    let dfx = this.datauxview.getDatascape();
    let camera = dfx.getCamera();
    let _view = view;
    if (!view) {
      let dr = this.getElemRadius(el);
      let target = this.getElemCenter(el);
      let ds = dr / Math.tan(camera.fov / 2);
      ds = Math.max(3, ds);
      _view = { distance: ds, target }
    }
    dfx.moveCamera(_view);
  }

  getElemRadius(el, _mesh = null) {
    let dfx = this.datauxview.getDatascape();
    let mesh = _mesh || dfx.getElementMesh(el);
    let c = mesh.getBoundingInfo().boundingSphere.radius;
    return c;
  }
  getElemCenter(el, _mesh = null) {
    let dfx = this.datauxview.getDatascape();
    let mesh = _mesh || dfx.getElementMesh(el);
    let c = mesh.getBoundingInfo().boundingSphere.centerWorld;
    let target = { x: c.x, y: c.y, z: c.z }
    return target;
  }

  showEngineModel(boo = true) {
    let engine = this.getMesh('iengine');
    engine.setEnabled(boo);
  }
  getMesh(id) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    return mesh;
  }

  getMeshName(n) {
    if (!n) {
      return 'unknown'
    }
    let arr = n.split(".");
    if (arr.length === 1) {
      return arr[0]
    }
    if (arr.length === 0) {
      return "unknown"
    }
    if (!isNaN(arr[arr.length - 1])) {
      return arr[arr.length - 2] + "." + arr[arr.length - 1]
    }
    return arr[arr.length - 1];
  }

  initExplodeMesh(id = 'imodel') {
    let meshes = [];
    if (!this.explosion) {
      this.shipComps.forEach((c) => {
        let comp = this.getMesh(c);
        meshes.push(comp);
        if(comp.getChildren().length){
          meshes.push(...comp.getChildMeshes());
        }else{
          meshes.push(comp);
        }

      })
      // let cm = ""
      // let centerMesh = ''
      // this.explosion_cm = centerMesh;
      this.explosion = new BABYLON.MeshExploder(meshes)
    }
  }

  applyExlude(light, mesh) {
    light.excludedMeshes.push(mesh);
    mesh.getChildMeshes().forEach((m) => {
      light.excludedMeshes.push(m);
    }
    );
  }
  getChildTransEx(id, cid) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    let meshes = mesh.getChildTransformNodes();
    let idx = meshes.findIndex(e => this.getMeshName(e.name) === cid);
    if (idx > -1) {
      return meshes[idx];
    }
    return null;
  }

  /**
   * code to fetch shapes and objects def for objects.json 
   *  and components def
   */
  getObjDef() {
    let scope = this;
    var el = scope.datauxview.getElementId("ValveTrains");
    var mesh = scope.dfx.getElementMesh(el);
    var meshes = mesh.getChildren();
    let shapes = [];
    let objects = []
    meshes.forEach((m) => {
      let mname = scope.getMeshName(m.name);
      let obj = {}
      obj["dfx-" + mname] = { "model": mname, "material": "custom-included", "size": 1 }
      shapes.push(obj);
      let prop = { "type": "static", "parent": "", "name": mname, "model": "dfx-" + mname, "place": { "pos": { "x": 0, "y": 0, "z": 0 }, "rot": { "x": 0, "y": 0, "z": 0 } } }
      objects.push(prop)
    })
    let controls = [];
    objects.forEach((m) => {
      let o = {
        "name": m.name, "id": m.name, "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false
      }
      controls.push(o)
    })
    return { shapes, objects, controls }
  }
  getObjDefJSON() {
    let def = this.getObjDef();
    console.log("------- SHAPES -------");
    console.log(JSON.stringify(def.shapes))
    console.log("------- OBJECTS -------");
    console.log(JSON.stringify(def.objects));
    console.log("------- CONTROLS -------");
    console.log(JSON.stringify(def.controls));
  }
  getMeshID(m) {
    let aname = m.id.split(".");
    let name = aname[aname.length - 1];
    return name;
  }
  getParentElemBound(mesh) {
    //let meshes = mesh.getChildMeshes();
    let c = this.getElemCenter(null, mesh);
    let r = this.getElemRadius(null, mesh);
    let l = 0
    /* if (meshes.length) {
      let cx = 0;
      let cy = 0;
      let cz = 0;
      meshes.forEach((m) => {
        if (!m.getChildren().length) {
          l++;
          let ce = this.getElemCenter(null, m);
          let _r = this.getElemRadius(null, m);
          r = Math.max(r, _r);
          cx += ce.x;
          cy += ce.y;
          cz += ce.z;

        }
      })
      cx = cx / l
      cy = cy / l
      cz = cz / l
      c = { x: cx, y: cy, z: cz }
    } */
    return [c, r];
  }

  applyParentChild() {
    let dfx = this.datauxview.getDatascape();
    this.shipComps.forEach((key) => {
      let parent = this.dbobj[key][1];
      let info = this.getCtrlData(key)
      if (info.isSub && info.children.length) {
        let c = info.children;
        c.forEach((cinfo) => {
          let id = cinfo['id'];
          if (id !== key) {
            let _child = this.dbchildobj[id][1];
            _child.setParent(parent);

            if (cinfo.isSub && cinfo.children.length) {
              let cc = cinfo.children;
              cc.forEach((ccinfo) => {
                let id = ccinfo['id'];
                if (id !== key) {
                  let _cchild = this.dbchildobj[id][1];
                  _cchild.setParent(_child);
                }
              })
            }
          }
        })
      }
    })
  }

  getCtrlData(val, prop = 'id', action = 'eq') {
    let data = null;
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((c) => {
        if (action === 'eq') {
          if (c[prop] == val) {
            data = c;
          }
        }
        if (action === 'contains') {
          if (c[prop].includes(val)) {
            data = c;
          }
        }
      })
    }
    return data;
  }
  camviews = {
    'engine-Amination': {
      "home": {
        "target": { x: 0.07, y: 1.11, z: -0.0968 }, "distance": 3.1, "yaw": -46, "pitch": 1
      },
      "top": { "target": { x: 0.07, y: 1.11, z: -0.0968 }, "distance": 3.1, "yaw": 270, "pitch": 89.9 },
      "left": { "target": { x: 0.07, y: 1.11, z: -0.0968 }, "distance": 3.1, "yaw": 0.09, "pitch": 27.85 },
      "right": { "target": { x: 0.07, y: 1.11, z: -0.0968 }, "distance": 3.1, "yaw": 179.9, "pitch": 27.85 },
      "back": { "target": { x: 0.07, y: 1.11, z: -0.0968 }, "distance": 3.1, "yaw": 89.9, "pitch": 27.85 },
      "front": { "target": { x: 0.07, y: 1.11, z: -0.0968 }, "distance": 3.1, "yaw": 269.9, "pitch": 27.85 },
    }
  }
  onChangeCameraPosition(camView) {
    console.log(camView)
    if (camView === 'home') {
      this.changeCamView('home')
    } else if (camView == "drag") {
      if (camView == 'drag') {
        this.dragMode = !this.dragMode;
        if (this.dragMode) {
          this.enableDragEngine();
        } else {
          this.removeDragEngine();
        }
      }
    } else if (camView == 'drag_reset') {
      if (this.mesh_explode) {
        this.resetMeshExplode();
        this.resetChildren();
        this.mesh_explode = false;
      } else {             
        this.resetChildren(); 
        // this.moveCameraTo(null, this.defCameraView);                     
      }  
      this.changeCamView('home');        
    } else if ((camView == 'left' || camView == 'right' || camView == 'back' || camView == 'back' || camView == 'top' || camView == 'front')) {
      this.changeCamView(camView);
      return;
    }
  } 

  resetChildren() {
    let keys = Object.keys(this.dbobj);
    keys.forEach((key) => {
      let info = this.getCtrlData(key);
      let isSub = info.isSub;
      if (isSub) {
        this.resetChild(key);
      }
    })
  }

  resetChild(m) {
    let obj = this.dbobj[m]
    if (obj) {
      let p = this.children[m].pos;
      let mesh = obj[1];
      mesh.position.x = p.x;
      mesh.position.y = p.y;
      mesh.position.z = p.z;
      mesh.getChildMeshes().forEach(_mesh => {
       let mname = this.getMeshName(_mesh.name);
       if(this.children[mname]){
        let cp = this.children[mname].pos;
        _mesh.position.x = cp.x;
        _mesh.position.y = cp.y;
        _mesh.position.z = cp.z;
       }
      })
    }

  }
  enableDragEngine() {
    let dfx = this.datauxview.getDatascape();
    this.shipComps.forEach((key) => {
      let child = this.dbobj[key][1];
      let info = this.getCtrlData(key)
      if (!child.isEnabled() || !info.isSub) {
        return;
      }

      let b = dfx.getDragBehavior([0, 0, 1])
      b.useObjectOrienationForDragging = false;
      b.updateDragPlane = false;
      child.addBehavior(b);
      this.dbobj[key][0] = b;
    })
  }
  removeDragEngine() {
    let keys = Object.keys(this.dbobj);
    keys.forEach((key) => {
      if (this.dbobj[key][0])
        this.dbobj[key][1].removeBehavior(this.dbobj[key][0]);
      this.dbobj[key][0] = null;
    })
  }

  changeCamView(v, vobj = false) {
    let view;
    let camviews;
    camviews = this.camviews["engine-Amination"];
    view = camviews[v];
    this.moveCameraTo(null, view)
  }

  explodeMesh(i = 1) {
    this.explosion.explode(i);
    setTimeout(()=>{
      let p = this.explosion._centerMesh.getAbsolutePosition();
      let camera = this.dfx.getCamera();
      camera.targetX.value = p.x;
      camera.targetY.value = p.y;
      camera.targetZ.value = p.z;
    })   
  }

  showHideLand(boo) {
    let dfx = this.datauxview.getDatascape();
    let m = this.datauxview.getElementId("land");
    let mesh = dfx.getElementMesh(m);   
    mesh.isVisible = boo;
    if (boo) {
      this.ctrlServ.modifyElement('land', { "x": 0, "y": -0.25, "z": 0 })
    }
  }

  resetMeshExplode() {
    this.showHideLand(true);
    this.explosion.explode(0);
    setTimeout(()=>{
      let p = this.explosion._centerMesh.getAbsolutePosition();
      let camera = this.dfx.getCamera();
      camera.targetX.value = p.x;
      camera.targetY.value = p.y;
      camera.targetZ.value = p.z;
    })    
  }

  cam_mode = '3D'
  onChangeCameraMode(camView) {
    this.cam_mode = camView;
    this.datauxview.CameraMode(camView);
    if (camView == '3D') {
      setTimeout(() => {
        this.changeCamView('home');
      }, 1500);
    }
  }

  /**
  * Zoom event to zoom in / out the venue
  */
  isMouseDown
  mousestate = "up"
  Zoom(key) {
    this.isMouseDown = true;
    this.datauxview.startZoom(key);
  }
  stopZoom() {
    this.isMouseDown = !true;
    this.datauxview.stopZoom();
  }
  @HostListener('document:mouseup', ['$event'])
  handleMouseUpEvent(event: MouseEvent) {
    if (this.isMouseDown) {
      this.targetClicked = true;
      this.stopZoom();
    }
    this.isMouseDown = !true;
    this.mousestate = "up";
    //this.informCanvasOfMouseUp();
    setTimeout(() => {
      this.targetClicked = !true;
    }, 750)
  }


  controlChangeObj
  onControlChange(data) {
    let key = data.name;
    let f = "";
    if (this.controlChangeObj) {
      f = this.controlChangeObj;
    }
    this.controlChangeObj = data.name;
    let state = data.state;
    let event = data.event;
    if (event === 'showhidecomp') {
      if (state) {
        let solidtrans = data.solidtrans;
        if (!solidtrans) {
          this.solidTransElem(key, solidtrans);
          this.showHideCompTargets(!this.multipleTagStatus);
          this.sensorHideShow(!this.sensorTargetOff);
          if (this.multipleTagStatus) {
            this.onShowAllTag({ state: true }, false);
          }
          this.reapplyDrag();
        } else {
          this.ctrlServ.showElement(key);
        }
      } else {
        this.ctrlServ.hideElement(key);
      }
    } else if (event === 'locate') {
      let compKey = data.key;
      let compId = data.id
      if (!state) {
        this.tagStatus = false;
        this.pickElement = false;
        // this.shipCompFocus(key);
        this.closeBack(this.shipCompsCntls['Components'][0], 'Components');
        this.resetElemState();
        this.stopEnvAnim(true);
        if (this.multipleTagStatus) {
          this.onShowAllTag({ state: true }, false);
        }
        this.showHideCompTargets(!this.multipleTagStatus);
        if (!this.globalPause) {
          this.compAnimStatus = 'playing';
          setTimeout(() => {
            this.animatorService.pauseAllAnim(false, true);
            this.animatorService.triggerPausedAnim(key);

            this.animatorService.showHideProps(true, key);
            this.reapplyDrag();
          }, 500)
        } else {
          //this.animatorService.triggerPausedAnim(key);
          this.animatorService.showHideProps(true, key);
        }

      } else {
        this.tagStatus = true;
        if (this.multipleTagStatus) {
          this.onShowAllTag({ state: false }, false);
          this.multipleTagStatus = true;
          this.animatorService.setTagStatus('multipleTagStatus', this.multipleTagStatus)
        }
        this.animatorService.showHideProps(!true);

        if (!this.globalPause) {
          this.animatorService.pauseAllAnim(true, true);
          this.compAnimStatus = 'paused';
        }

        this.animatorService.stopAnim(key, true, true);
        let el = this.datauxview.getElementId(key);
        // this.showTag(el);

        // this.onShowAllTag({state:false});
        this.showHideCompTargets(false);
        //this.animatorService.stopAllAnim(false);

        setTimeout(() => {
          this.focusElem(key, state);
          let passValue = { 'key': compKey, 'id': compId };
          this.onLocCtl(passValue, key);
          this.clearChildCompDrag();
          this.enableChildCompDrag(key);
        }, 100)
      }
      this.cameraHideShow(!this.cameraTargetOff);
      this.sensorHideShow(!this.sensorTargetOff);

    } else if (event === 'showassembleparts') {
      if (state) {
        this.ctrlServ.modify(key);
        this.ctrlServ.showElement(key);
      } else {
        this.ctrlServ.hideElement(key);
      }
    } else if (event === 'solidtrans') {
      this.solidTransElem(key, state);
      this.showHideCompTargets(!this.multipleTagStatus);
      this.sensorHideShow(!this.sensorTargetOff);
      if (this.multipleTagStatus) {
        this.onShowAllTag({ state: true }, false);
      }
      this.reapplyDrag();
    } else if (event === 'showhidetrans') {
      this.showHideTransElem(state);
      this.showHideCompTargets(!this.multipleTagStatus);
      this.sensorHideShow(!this.sensorTargetOff);
      this.reapplyDrag();
    } else if (event === 'inspectelem') {
      this.viewElement(key, state);
    }


  }

  closeBack(comp, key) {
    if (this.objDrillDownDataPath[comp.parentId] != undefined) {
      this.shipCompsCntls[key] = this.objDrillDownDataPath[comp.parentId];
      this.resetShipCompCtls();
      this.broadcastInfo({ src: 'starterapp', event: 'drill-down', data: this.shipCompsCntls, key: "" });
    }
  }

  viewElement(x, state) {
    this.removeDrag("null", true);
    this.shipComps.forEach((comp) => {
      let info = this.getCtrlData(comp);
      if (!info.isSub) {
        return;
      }
      if (state) {
        if (comp == x) {
          this.solidTransElem(comp, true);
        } else {
          this.solidTransElem(comp, false);
        }
      } else {
        this.solidTransElem(comp, true);
      }
    });
    this.reapplyDrag();
  }

  /***
   * Show All Tag for object
   */
  multiTagShowList = [];
  multipleTagStatus: boolean = false;
  showExternalTools = false;
  onShowAllTag(e, status) {
    setTimeout(() => {
      this.showExternalTools = true;
    }, 1000);
    if (this.viewMode !== 'wireframe') {
      if (this.pickElement) {
        if (this.selectedelem != "") {
          let ele = this.datauxview.getDatascape().props(this.selectedelem);
          this.onControlChange({ event: 'locate', name: ele.id, state: false });
        }
      }
      _console.log("showTag");
      this.multipleTagStatus = e.state;
      this.animatorService.setTagStatus('multipleTagStatus', this.multipleTagStatus)
      this.shipCompFocusStatus();
      if (!this.shipCompFocusState) {
        this.pickElement = e.state;
      } else {
        this.pickElement = false;
      }
      if (this.disableTrans) {
        this.showHideCompTargets(false)
      } else {
        this.showHideCompTargets(!this.multipleTagStatus)
      }

      this.shipComps.forEach((element, i) => {
        var checked = true;
        let info = this.getCtrlData(element);
        if (info.isSub) {
          let el = this.datauxview.getElementId('tooltip_' + element);
          if (e.state) {
            if (!this.shipCompFocusState) {
              let cat = Object.keys(this.shipCompsCntls);
              cat.forEach((catElement) => {
                this.shipCompsCntls[catElement].forEach((sensorEle, i) => {
                  if (this.shipCompsCntls[catElement][i].isSub) {
                    let idx = this.shipCompsCntls[catElement].findIndex(ele => ele.id == element);
                    if (idx > -1) {
                      if (!this.shipCompsCntls[catElement][idx].selected) {
                        checked = false;
                      }
                    }
                  }
                });
              });
              console.log("multi", element, checked)
              if (checked) {
                // this.multiTagShowList.push(element);
                this.addObserver(el);
                // let ele = this.datauxview.getDatascape().props(el);
              } else {
                let dom = document.getElementById('tooltip_' + element);
                if (dom) {
                  dom.style.display = "none";
                  this.removeObserver(el);
                }
              }
            }
            // this.observableMultiTag(ele);

          } else {
            // if(! this.shipCompFocusState ){
            let dom = document.getElementById('tooltip_' + element);
            if (dom) {
              dom.style.display = "none";
              this.removeObserver(el);
            }
            // let ele = this.datauxview.getDatascape().props(el);
            // }
            // this.observableMultiTag(ele);
          }
          if (status == true) {
            //this.shipCompFocus(element, 'multiTag')
          }
        }
      })
    }
  }

  solidTransElem(id, solid) {
    let dfx = this.getDatascape();
    let elem = this.datauxview.getElementId(id);
    let info = this.getCtrlData(id);
    let profile = info ? info.profile || 'regular' : 'regular';
    info.opacity = 'solid';
    info.checked = !false;
    if (this.viewObjectMode === 'texture') {
      profile = 'regular'
    }
    if (!solid) {
      if (profile !== 'regular') {
        profile = "transparent"
      } else {
        profile = 'transparent';
      }
      if (!this.transMode) {
        profile = 'invisible';
      }
      info.opacity = 'transparent'
      info.checked = false;
    }
    dfx.modify(elem, { profile });
    if (info.children.length && profile !== 'invisible') {
      // this.applyProfileToChildren(info);
    }
    if (info && info.sensors) {
      info.sensors.forEach((sensor) => {
        let _profile = profile === 'invisible' ? profile : 'regular';
        let elem = this.datauxview.getElementId(sensor);
        let isSensorT = this.sensors.includes(sensor) && sensor.includes('target');
        let isCameraT = this.cameras.includes(sensor) && sensor.includes('target');
        if (isSensorT && this.sensorTargetOff) {
          _profile = 'invisible'
        }
        if (isCameraT && this.cameraTargetOff) {
          _profile = 'invisible'
        }
        if (elem) {
          dfx.modify(elem, { profile: _profile });
        }
      })
    }
  }

  showHideCompTargets(_boo, key = 'all') {
    let boo = _boo;
    if (_boo && this.compTargetOff) {
      boo = false;
    }
    this.compTargets.forEach((c) => {
      if (key === 'all' || c === key) {
        let arr = this.comp_target_arr[c];
        if (arr && arr.length) {
          let el = arr[0];
          let info = this.getCtrlData(c);
          let elm = this.getDatascape().getElementMesh(el);
          let cboo = this.isCompVisible(c) && info.selected;
          elm.isVisible = boo ? cboo : boo;
          elm.getChildMeshes().forEach((m) => {
            m.isVisible = elm.isVisible;
          })
          if (elm.isVisible) {
            //this.changeTargetProfile(arr[1], !info.playing)
          }

        }
      }
    })
  }
  getDatascape() {
    return this.datauxview.getDatascape();
  }

  isCompVisible(c) {
    let comp = this.datauxview.getElementId(c);
    let dfx = this.getDatascape();
    let props = dfx.props(comp);
    let vis = props.profile.visible;
    return vis;
  }

  sensorHideShow(e, hideSens = false) {
    // _console.log(e);
    // let allObject = this.datauxview.allObjects();
    // let allObjKeys = Object.keys(allObject);
    this.sensorTargetOff = !e;
    this.shipSmartSensor.forEach((element, i) => {
      var object: any = element.target.split('_');
      let parent_data = null;
      let eboo = e;
      if (object[0] == 'sensor') {
        let datascape = this.datauxview.getDatascape();
        let target = this.datauxview.getElementId(element.target);
        let sensor = this.datauxview.getElementId(element.id);
        let domodify = true;
        if (this.disableTrans) {
          let props = datascape.props(sensor);
          domodify = props.profile.visible;
          this.shipCompFocusStatus();
          // if (!this.shipCompFocusState) {
          //   domodify =
          // }
          let idx = this.shipCompFocusElem.sensors.findIndex(e => e == element.id)
          if (idx > -1) {
            domodify = true;
          }
        } else {
          parent_data = this.getCtrlData(element.id, 'sensors', 'contains');
          if (parent_data) {
            let parent = this.datauxview.getElementId(parent_data.id);
            let props_p = datascape.props(parent);
            domodify = props_p.profile.visible;
          }
        }
        if (domodify) {
          if (parent_data) {
            if (!parent_data.selected) {
              eboo = false;
            }
          }
          if (eboo) {
            datascape.modify(target, { profile: 'regular' })
            datascape.modify(sensor, { profile: 'regular' })
          } else {
            datascape.modify(target, { profile: 'invisible' })
            datascape.modify(sensor, { profile: 'invisible' })
          }
          if (hideSens || eboo) {
            if (eboo) {
              datascape.modify(sensor, { profile: 'regular' })
            } else {
              datascape.modify(sensor, { profile: 'invisible' })
            }
          }
        }
      }
    });
  }

  /***
 * shipcomponent status check
 */
  shipCompFocusState: any = false;
  shipCompFocusElem: any = '';
  shipCompFocusStatus() {
    this.shipCompFocusState = false;
    this.shipCompFocusElem = '';
    let cat = Object.keys(this.shipCompsCntls);
    cat.forEach(element => {
      let idx = this.shipCompsCntls[element].findIndex(e => e.focus == true);
      if (idx > -1) {
        this.shipCompFocusState = true;
        _console.log("shipCompFocusStatusr", this.shipCompFocusState);
        this.shipCompFocusElem = this.shipCompsCntls[element][idx];
      }
    })
    _console.log("shipCompFocusStatus", this.shipCompFocusState)
  }

  /***
  * add an Observer attach to 3d object
  */
  addObserver(elem) {
    if (!elem) {
      return;
    }
    this.datauxview.getDatascape().attach(elem, {
      observer: {
        callback: this.assignTagProperties.bind(this),
        options: { no2D: false }
      }
    });
  }

  /**
   * Remove an Observer detach to 3d object
   */
  removeObserver(elem) {
    if (!elem) {
      return;
    }
    this.datauxview.getDatascape().detach(elem, {
      observer: {
        callback: this.assignTagProperties.bind(this),
        options: { no2D: false }
      }
    });
  }

  /***
  * tag observer properties
  */
  assignTagProperties(options) {
    const { id, position, position2D, uuid, tag, visibility } = Object.assign({}, options);
    // if (this.tagElement.id === id) {
    // _console.log("obc", this.tagElement.id, id)
    // var pop = this.objTag.nativeElement;
    if (this.multipleTagStatus) {
      let elem = this.datauxview.getElementId(id);
      let props = this.datauxview.getDatascape().props(elem);
      var pop = document.getElementById(id);
      this.objObserver(pop, position2D, props);
    } else {
      if (this.selectedLabel === id) {
        var pop = document.getElementById(this.selectedLabel);
        // var pop = document.getElementById('label_' + this.tagElement.id);
        this.objObserver(pop, position2D, this.tagElement);
      }
    }
    // }
  }

  /****
 * observable Tag
 */
  tagElement: any = "";
  selectEle: any = '';
  tagAfterTagIdArr: any = [];
  objObserver(pop, position, element) {
    if (element != "") {
      // position[0]=this.hitPosition.x<0?this.hitPosition.x*-1500:this.hitPosition.x*1500;
      // position[1]=this.hitPosition.y<0?this.hitPosition.y*-500:this.hitPosition.y*500;
      // position[0]=this.hitPosition.x*1800;
      // position[1]=this.hitPosition.y*400;
      //_console.log(element.id, "position :", position, this.hitPosition);
      const x = position[0];
      const y = position[1];
      let info = this.getCtrlData(element.id);
      // const canvas = null;
      // var canvas = this.datauxview.getCanvas();
      // console.log("canvas", canvas.width,canvas.height);
      const dpr = window.devicePixelRatio;
      // const within_window = (x > 10 && x < canvas.width) && (y > 10 && y <= canvas.height);
      if (this.pickElement) {
        // if (within_window) {
        let mpop = pop.getElementsByClassName("tooltip_popup")[0]
        // _console.log("material",element.profile.material)
        var width = -mpop.offsetWidth / 2;//1555 - window.innerWidth;
        var height = 35;// 815 - window.innerHeight;
        pop.style.left = (Number(x) + width) + 'px';
        pop.style.bottom = (Number(y) + height) + 'px';
        // console.log(window.innerWidth, window.innerHeight, x, (Number(x) - 50) + 'px', y, (Number(y) + 25) + 'px')
        var material = info && info.profile ? info.profile.split('_')[1] : "#fefefe";
        let color = 'black'
        if (this.viewObjectMode === 'texture') {
          material = 'lightgrey';
          //color='white';
        }
        // if (element.profile.material == undefined) {
        //   material = 'grey';
        // }
        // _console.log("color_code",material);
        // pop.children[0].children[0].children[0].children[0].style.color=color;
        // pop.children[0].children[0].children[0].children[0].style.backgroundColor = material;
        //  if (this.tagAfterTagIdArr.length == 0) {
        //   this.tagAfterTagIdArr.push(element.id);
        //   document.head.appendChild(document.createElement("style"));
        //   document.head.getElementsByTagName('style')[Number(this.styleLength)].innerHTML = "#tooltip_popup_content_" + element.id + "::after {border-color:" + material + " !important;}";
        //   this.styleLength = this.styleLength + 1;
        // } else {
        //   let idx = this.tagAfterTagIdArr.findIndex(e => e == element.id);
        //   if (idx < 0) {
        //     this.tagAfterTagIdArr.push(element.id);
        //     document.head.appendChild(document.createElement("style"));
        //     document.head.getElementsByTagName('style')[Number(this.styleLength)].innerHTML = "#tooltip_popup_content_" + element.id + "::after {border-color:" + material + " !important;}";
        //     this.styleLength = this.styleLength + 1;
        //   }
        // }
        pop.style.display = 'block';
        pop.style.position = 'absolute';
        // pop.dataset.lastx = Number(x);
        // pop.dataset.lasty = Number(y);
        // } else {
        //   pop.style.display = 'none';
        // }
      } else {
        if (pop != null) {
          pop.style.display = 'none';
        }
      }
    }
  }
  showHideElem(id, state) {
    let dfx = this.getDatascape();
    let elem = this.datauxview.getElementId(id);
    let info = this.getCtrlData(id);
    let profile = info ? info.profile || 'regular' : 'regular';
    if (!info.isSub) {
      return
    }
    if (this.viewObjectMode === 'texture') {
      profile = 'regular'
    }
    if (!state) {
      profile = 'invisible';
    } else {
      if (info.opacity === 'transparent') {
        profile = "transparent"
      }
    }
    info.visible = state;
    dfx.modify(elem, { profile });
    if (info.children.length && profile !== 'invisible') {
      // this.applyProfileToChildren(info);
    }
    /* if (info && info.id.includes("_arm")) {
      this.linkboatProfile(dfx, info.id, profile);
    } */
  }
  reapplyDrag() {
    if (!this.dragMode) {
      this.removeDrag("null", true);
      return;
    }
    let dfx = this.datauxview.getDatascape();
    this.shipComps.forEach((key) => {
      let child = this.dbobj[key][1];
      if (!child.isEnabled()) {
        return;
      }
      this.removeDrag(key);
      child.isPickable = !false;
      let b = dfx.getDragBehavior([0, 0, 1])
      b.useObjectOrientationForDragging = false;
      child.addBehavior(b);
      this.dbobj[key][0] = b;
    })
  }

  removeDrag(m, except = false) {
    if (m && except) {
      let keys = Object.keys(this.dbobj);
      keys.forEach((key) => {
        if (key != m) {
          if (this.dbobj[key][0])
            this.dbobj[key][1].removeBehavior(this.dbobj[key][0]);
          this.dbobj[key][0] = null;
        }
      })
    } else if (m) {
      if (this.dbobj[m] && this.dbobj[m][0]) {
        this.dbobj[m][1].removeBehavior(this.dbobj[m][0]);
        this.dbobj[m][0] = null;
      }
    }
  }

  resetShipCompCtls() {
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((c) => {
        c.focus = false;
        c.opacity = 'solid';
        c.selected = true;
        c.visible = true;
      })
    }
  }

  /**
  * Camera Hide/ Show
  */
  cameraHideShow(e, hidecam = false) {
    // _console.log(e);
    // let allObject = this.datauxview.allObjects();
    // let allObjKeys = Object.keys(allObject);
    this.cameraTargetOff = !e;
    this.shipCameras.forEach((element, i) => {
      var object: any = element.target.split('_');
      if (object[0] == 'camera') {
        let datascape = this.datauxview.getDatascape();
        let target = this.datauxview.getElementId(element.target);
        let camera = this.datauxview.getElementId(element.id);
        let domodify = true;
        if (this.disableTrans) {
          let props = datascape.props(camera);
          domodify = props.profile.visible;
        } else {
          let parent_data = this.getCtrlData(element.id, 'sensors', 'contains');
          if (parent_data) {
            let parent = this.datauxview.getElementId(parent_data.id);
            let props_p = datascape.props(parent);
            domodify = props_p.profile.visible;
          }
        }
        if (domodify) {
          if (e) {
            datascape.modify(target, { profile: 'regular' })
          } else {
            datascape.modify(target, { profile: 'invisible' })
          }
          if (hidecam || e) {

            // _console.log("camera", element, e);
            if (e) {
              datascape.modify(camera, { profile: 'regular' })
            } else {
              datascape.modify(camera, { profile: 'invisible' })
            }
          }
        }
      }
      // if (object[1] == 'RIM162ESSM1') {
      //   let datascape = this.datauxview.getDatascape();
      //   let camera = this.datauxview.getElementId(element);
      //   // _console.log("camera", element, e);
      //   if (e) {
      //     datascape.modify(camera, { profile: 'regular' })
      //   } else {
      //     datascape.modify(camera, { profile: 'invisible' })
      //   }
      // }
    });
  }

  lastCamState = null;
  componentLevel = [];
  componentDef = {};
  resetElemState(state = 'solid', exp = null) {
    let shipElems = this.shipElems;
    let dfx = this.getDatascape();
    if (state == 'solid') {
      this.componentLevel.pop();
      shipElems = this.shipElems;
      if (!this.componentLevel.length) {
        this.disableTrans = false;
        this.focusMode = false;
      } else {
        let key = this.componentLevel[this.componentLevel.length - 1];
        this.focus_title = this.componentDef[key]['name'];
        this.focus_col = this.componentDef[key]['color'];
        this.focusChildElem(key);
      }
    } else {
      this.focusMode = true;
      this.disableTrans = true;
      this.componentLevel.push(exp);
      if (this.componentLevel.length >= 2) {
        let len = this.componentLevel.length;
        let key = this.componentLevel[len - 2];
        shipElems = this.getChildElems(key);
      }
    }
    this.shipElems.forEach((c) => {
      if (!this.isSubSys(c)) {
        return
      }
      let elem = this.datauxview.getElementId(c);
      let info = this.getCtrlData(c);
      let profile = info ? info.profile || 'regular' : 'regular';
      if (this.viewObjectMode === 'texture') {
        profile = 'regular'
      }
      if (state != 'solid') {
        profile = 'invisible'
      } else {
        if (info) {
          if (info.opacity === 'transparent' && info.checked === false) {
            if (profile !== 'regular') {
              profile = "transparent"
            } else {
              profile = 'transparent';
            }
            if (!this.transMode) {
              profile = 'invisible';
            }
          } else {
            info.opacity = 'solid'
          }
        }
      }
      dfx.modify(elem, { profile: "regular" });
      dfx.modify(elem, { profile });
      if (info.children.length && profile !== 'invisible') {
        // this.applyProfileToChildren(info);
      }
      //this.applyLightConeProfile()
      let f = this.getFocusElem();
      if (f) {
        let i = this.getCtrlData(f);
        i.focus = false;
      }
      if (info && info.sensors) {
        info.sensors.forEach((sensor) => {
          let _profile = profile === 'invisible' ? profile : 'regular';
          let elem = this.datauxview.getElementId(sensor);
          let isSensorT = this.sensors.includes(sensor) && sensor.includes('target');
          let isCameraT = this.cameras.includes(sensor) && sensor.includes('target');
          if (isSensorT && this.sensorTargetOff) {
            _profile = 'invisible'
          }
          if (isCameraT && this.cameraTargetOff) {
            _profile = 'invisible'
          }
          if (elem) {
            dfx.modify(elem, { profile: _profile });
          }

        })
      }
    })
    if (exp) {
      let elem = this.datauxview.getElementId(exp);
      let info = this.getCtrlData(exp);
      let profile = info ? info.profile || 'regular' : 'regular';
      this.focus_title = "";
      this.focus_col = "#fff";
      if (this.viewObjectMode === 'texture') {
        profile = 'regular'
      }
      if (info) {
        this.focus_title = info.name;
        this.focus_col = info.color;
        this.componentDef[this.focus_title] = { name: this.focus_title, color: this.focus_col };
        info.focus = true;
        /* if (profile !== 'regular') {
          profile = info.profile + '_transparent'
        } else {
          profile = 'transparent';
        }
        info.opacity = 'transparent' */
      }
      dfx.modify(elem, { profile });
      if (info.children.length && profile !== 'invisible') {
        // this.applyProfileToChildren(info);
      }
      if (info && info.sensors) {
        info.sensors.forEach((sensor) => {
          let profile = 'regular';
          let elem = this.datauxview.getElementId(sensor);

          if (elem) {
            dfx.modify(elem, { profile });
          }
        })
      }
    } else {
      if (this.lastCamState) {
        this.moveCameraTo(null, this.lastCamState);
        this.lastCamState = null;
      }
    }
  }

  /* * * * 
  * drag for child component in focusmode start
  * * * */
  enableChildCompDrag(key, compKey = 'Components') {
    let dfx = this.datauxview.getDatascape();
    let parent_el = this.datauxview.getElementId(key);
    if (!parent_el) return;
    this.shipCompsCntls[compKey].forEach(c => {
      let cid = c['id'];
      if (cid === key) {
        let hmesh = this.dfx.getElementMesh(parent_el);
        if (!this.dbchildobj[cid]) {
          let b = dfx.getDragBehavior([0, 0, 1]);
          this.dbchildobj[cid] = [b, hmesh];
        }
      } else {
        let child = this.dbchildobj[cid][1];
        let info = this.getCtrlData(cid);
        if (!child.isEnabled() || !info.isSub) {
          return;
        }
        child.isPickable = !false;
        let b = dfx.getDragBehavior([0, 0, 1])
        b.useObjectOrienationForDragging = false;
        b.updateDragPlane = false;
        child.addBehavior(b);
        this.dbchildobj[cid][0] = b;
      }
    });
    this.broadcastInfo({ src: 'starterapp', event: 'drill-down', data: this.shipCompsCntls, key: "" });
  }
  clearChildCompDrag(compKey = 'Components') {
    this.resetChildCompDrag(compKey);
    this.removeChildCompDrag(null, true, compKey);
  }
  resetChildCompDrag(compKey = 'Components') {
    this.shipCompsCntls[compKey].forEach((c) => {
      let cid = c['id'];
      let obj = this.dbchildobj[cid];
      if (obj) {
        let p = this.children[cid].pos;
        let mesh = obj[1];
        mesh.position.x = p.x;
        mesh.position.y = p.y;
        mesh.position.z = p.z;
      }
    });
  }
  removeChildCompDrag(m, except = false, compKey = 'Components') {
    if (m && except) {
      this.shipCompsCntls[compKey].forEach((c) => {
        let cid = c['id'];
        if (this.dbchildobj[cid]) {
          this.dbchildobj[cid][1].removeBehavior(this.dbchildobj[cid][0]);
          this.dbchildobj[cid][0] = null;
        }
      });
    } else if (m) {
      if (this.dbchildobj[m] && this.dbchildobj[m][0]) {
        this.dbchildobj[m][1].removeBehavior(this.dbchildobj[m][0]);
        this.dbchildobj[m][0] = null;
      }
    }
  }

  stopEnvAnim(reset = false) {
    let datascape = this.datauxview.getDatascape();
    let scene = datascape.getCamera().getScene();
    let land = this.datauxview.getElementId('land');
    clearInterval(this.envID);
    this.envID = null;
    if (reset) {
      scene.clearColor.r = this.env_black.r;
      scene.clearColor.g = this.env_black.g;
      scene.clearColor.b = this.env_black.b;
      this.env_black_a = this.clone(this.env_black);
      // datascape.modify(land, { profile: 'regular' })
      this.showHideLand(true);
    }
  }

  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  getFocusElem() {
    let foc_elem = null;
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((c) => {
        if (c.focus) {
          foc_elem = c.id;
        }
      })
    }
    return foc_elem;
  }
  isSubSys(c) {
    let info = this.getCtrlData(c);
    return info.isSub;
  }

  getChildElems(key) {
    let shipElems = [];
    if (!this.objDrillDownDataPath) return shipElems;
    let shipCompCtls = this.objDrillDownDataPath[key];
    let comp = shipCompCtls.find(el => el.id === key);
    if (comp && comp.children.length) {
      shipElems = comp.children.map(el => el.id);
    }
    return shipElems;
  }

  focusChildElem(id) {
    let camera = this.dfx.getCamera();
    let elem = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(elem);
    if (!this.lastCamState) {
      this.lastCamState = this.getCamState();
    }
    let p = this.compDefPos[id];
    let _view = null;
    if (p && p.bound) {
      let dr = p.bound[1];
      let target = p.bound[0];
      let ds = dr / Math.tan(camera.fov / 2);
      ds = Math.max(3, ds);
      _view = { distance: ds, target: this.getAverageCenter(mesh) }
    }
    if (_view) {
      this.moveCameraTo(null, _view);
    } else {
      this.moveCameraTo(elem);
    }
  }

  onLocCtl(event, key) {
    let info;
    let objData = this.shipCompsCntls[event.key];
    let IndexData = objData.findIndex(data => data.id == event.id);
    if (IndexData != -1) {
      info = this.shipCompsCntls[event.key][IndexData]
      this.shipCompsCntls[event.key] = info['children']
      this.generateParentId(info['children'], event.id);
      this.objDrillDownDataPath[event.id] = objData;
    }
    this.resetShipCompCtls();
    this.bckupShip_comp_ctl_list = JSON.stringify(this.shipCompsCntls)
  }

  generateParentId(children, parentId) {
    children.forEach(element => {
      element['parentId'] = parentId;
    });
  }

  /**
* method for get center position of child mesh
*/
  getAverageCenter(m) {
    let meshes = m.getChildMeshes();
    let l = meshes.length;
    let c = [0, 0, 0]
    meshes.forEach((mesh) => {
      let pt = mesh.getBoundingInfo().boundingSphere.centerWorld
      c[0] += pt.x; c[1] += pt.y; c[2] += pt.z;
    });
    return { x: c[0] / l, y: c[1] / l, z: c[2] / l }
  }

  getCamState() {
    let dfx = this.getDatascape();
    let cam = dfx.getCamera();
    let distance = cam.distance.value;
    let target = { x: cam.targetX.value, y: cam.targetY.value, z: cam.targetZ.value };
    let yaw = cam.yaw_deg.value;
    let pitch = cam.pitch_deg.value;
    let view = { distance, target, yaw, pitch };
    return view;
  }

  focusElem(id, state) {
    let camera = this.dfx.getCamera();
    let s = state ? 'hide' : 'solid';
    this.resetElemState(s, id);
    let elem = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(elem);
    this.animEnv();
    if (!this.lastCamState) {
      this.lastCamState = this.getCamState();
    }
    let p = this.compDefPos[id];
    let _view = null;
    if (p && p.bound) {
      let dr = p.bound[1];
      let target = p.bound[0];
      let ds = dr / Math.tan(camera.fov / 2);
      ds = Math.max(3, ds);
      _view = { distance: ds, target: this.getAverageCenter(mesh) }
    }
    if (_view) {
      this.moveCameraTo(null, _view);
    } else {
      this.moveCameraTo(elem);
    }
  }
  _alreadyinframe: any;
  env_black = { r: 0.85, g: 0.85, b: 0.85, a: 1 };
  env_sky = { r: 0.65, g: 0.65, b: 0.65, a: 1 };
  env_black_a = { r: 0.85, g: 0.85, b: 0.85, a: 1 };
  envID
  animEnv() {
    let m = this.env_sky.r - this.env_black.r;
    let time = 100;
    let dm = m / time;
    let r = this.env_black_a.r;
    let g = this.env_black_a.g;
    let b = this.env_black_a.b;
    let datascape = this.datauxview.getDatascape();
    let scene = datascape.getCamera().getScene();
    let land = this.datauxview.getElementId('land');
    if (this.envID) {
      //this.stopEnvAnim();
      return;
    }
    //datascape.modify(land, { profile: 'invisible' })
    this.showHideLand(!true);
    this.envID = setInterval(() => {
      r = r + dm;
      g = g + dm;
      b = b + dm;
      scene.clearColor.r = r;
      scene.clearColor.g = g;
      scene.clearColor.b = b;
      this.env_black_a = { r, g, b, a: 1 };
      if (r >= this.env_sky.r) {
        this.stopEnvAnim();
      }
    }, 1)
  }
  closeSubSystemView() {
    // this.processToAnimate(this.tagElement.id,false)
    this.focusMode = false;
    let f = this.getFocusElem()
    this.onControlChange({ event: 'locate', name: f, state: false });
    this.broadcastInfo({ src: 'main', event: 'close-focus-mode', data: false });
  }

  objDrag: boolean = false;
  altKey: boolean = false;
  onHoverElem: any;
  dragChange(e) {
    _console.log("drag", e);
    this.objDrag = e === true;
    if (!this.objDrag) {
      if (this.onHoverElem != '') {
        this.offHover(this.onHoverElem);
      }
      if (e === 'dblclick' || this.altKey) {
        this.onDoubleClick();
      } else {
        /* setTimeout(()=>{
          let isCanvas = document.activeElement.tagName==='CANVAS';
          if(isCanvas&&!this.targetClicked){
            if(this.animStatus==='playing'){
              this.triggerCompAnim("CH148");
            }
          }
        },500) */
        if (this.pickEvent) {
          this.pickDragObject();
          // this.pickEvent=false;
        }
      }
    }
    this.pickEvent = false;
  }
  onDoubleClick() {
    let dfx = this.getDatascape();
    if (dfx) {
      let hp = dfx.getHitPosition();
      if (hp.pickedPoint) {
        let target = { x: hp.pickedPoint.x, y: hp.pickedPoint.y, z: hp.pickedPoint.z };
        this.moveCameraTo(null, { target });
      }
    }
  }
  isTarget(el) {
    let dfx = this.getDatascape()
    let props = dfx.props(el);
    let id = props.id;
    let targ = this.sensors.includes(id) || this.cameras.includes(id);
    return targ;
  }
  pickDragObject() {
    if (this.viewMode != 'wireframe' && this.pickedElement) {
    }
  }

    /***
   * Add Pickleft event start
   */
     tagObjectList: any;
     pickedElement: any;
     hitPosition: any;
     pickleftAttach() {
       // this.pickleftAttachStatus= true;
       // let  allObject = this.datauxview.allObjects();
       // let allObjKeys = Object.keys(allObject);
       // this.tagObjectList = allObjKeys;
      //  var shipCombainSensor = this.shipComps.concat(this.sensors);
      //  //_console.log("shipCombainSensor", shipCombainSensor.length, this.shipComps.length, this.sensors.length);
      //  var shipCombainSensorTarget = shipCombainSensor.concat(this.cameras)
      //  //_console.log("shipCombainSensorTarget", shipCombainSensorTarget.length, this.cameras.length);
      //  shipCombainSensorTarget.forEach((element, i) => {
      //    //_console.log("pickaddObj", element)
      //    let el = this.datauxview.getElementId(element);
      //    let info = this.getCtrlData(element);
      //    let isSub = info && info.isSub;
      //    let isSensor = this.sensors.includes(element) || this.cameras.includes(element)
      //    if (isSub || isSensor) {
      //      this.datauxview.getDatascape().attach(el, {
      //        actions: {
      //          pickLeft: [(evt, elem) => {
      //            //_console.log("event", evt);
      //            if (evt.button === 0) {
      //              this.pickedElement = elem;
      //              this.pickEvent = true;
      //            }
      //          }]
      //          // hoverOn: [(evt, elem) => {this.onHoverElem=true; this.onHover(elem); }],
      //          // hoverOff: [(evt, elem) => { this.onHoverElem=false; this.offHover(elem); }],
      //        }
      //      });
      //    }
      //  });
       this.shipComps.forEach((element, i) => {
         // _console.log("hover", element)
         let el = this.datauxview.getElementId(element);
         let info = this.getCtrlData(element);
         let isSub = info && info.isSub;
         if (isSub) {
           this.datauxview.getDatascape().attach(el, {
             actions: {
               pickLeft: [(evt, elem) => {
                 if (evt.button === 0) {
                   let props = this.datauxview.getDatascape().props(elem);
                   let comp = props['id'];
                   if (this.mesh_explode) {
                     if (this.focusMode) return;
                     let info = this.getCtrlData(comp);
                     this.broadcastInfo({ src: 'main', event: 'show-focus-mode', data: info, key: "" });
                   }
                 }
               }],
               hoverOn: [(evt, elem) => {
                 if (this.testMode) {
                   return;
                 }
                 if (this.mousestate == 'down') {
                   if (this.onHoverElem) {
                     this.offHover(this.onHoverElem);
                   }
                   return
                 }
                 this.onHoverElem = elem;
                 let dfx = this.getDatascape();
                 let hp = dfx.getHitPosition()
                 // this.hitPosition = hp.pickedPoint;
                 this.hitPosition = this.compDefPos[this.datauxview.getDatascape().props(elem).id].bound[0];
                 var id = this.datauxview.getDatascape().props(elem).id;
                 _console.log(this.datauxview.getDatascape().props(elem).id, this.compDefPos[this.datauxview.getDatascape().props(elem).id].bound[0], "onHover");
                 // setTimeout(() => {
                 if (this.onHoverElem) {
                   let props1 = this.datauxview.getDatascape().props(elem);
                   let props2 = this.datauxview.getDatascape().props(this.onHoverElem);
                   if (props1.id === props2.id) {
                     if (this.focusMode) return;
                     this.onHover(elem);
                   }
                 }
                 // }, 500)
               }],
               hoverOff: [(evt, elem) => {
                 this.onHoverElem = elem; this.offHover(elem);
               }],
             }
           });
         }
   
       });
       // this.generate();
     }
     checked: any = true;
     onHover(elem) {
       this.onHoverElem = elem;
       _console.log("hoveron", elem);
       let ele = this.datauxview.getDatascape().props(elem);
       _console.log("hoveron", elem, ele);
       this.shipCompFocusStatus();
       let info = this.getCtrlData(ele.id);
       let isSub = info && info.isSub;
       //uncheck
       this.checked = true;
       let cat = Object.keys(this.shipCompsCntls);
       cat.forEach((catElement) => {
         this.shipCompsCntls[catElement].forEach((sensorEle, i) => {
           if (this.shipCompsCntls[catElement][i].isSub) {
             let idx = this.shipCompsCntls[catElement].findIndex(e => e.id == ele.id);
             if (idx > -1) {
               if (!this.shipCompsCntls[catElement][idx].selected) {
                 this.checked = false;
               }
             }
           }
         });
       });
       if (this.checked && !this.multipleTagStatus && !this.shipCompFocusState && this.viewMode == 'solid' && isSub) {
         // this.addObserver(elem);
          //this.observableTag(ele);
         this.tagElement = ele;
         this.pickElement = true;
         if (this.mesh_explode) {
           this.focus_title = info.name;
         } else {
           //this.createLabelObject('cube', this.hitPosition, ele.id);
         }
       }
     }
     offHover(elem) {
       _console.log("hoveroff", elem)
       this.onHoverElem = '';
       if (this.mesh_explode && !this.focusMode) {
         this.focus_title = ""
       }
       this.focus_title
       // if(!this.multipleTagStatus && !this.shipCompFocusState && this.viewMode == 'solid' && this.animStatus !== 'playing'){
       if (this.tagElement != '') {
         document.getElementById('tooltip_' + this.tagElement.id).style.display = "none";
         // document.getElementById('label_' + this.tagElement.id).style.display = "none";
         // this.onControlChange({event: 'locate',name:this.tagElement.id,state:false });
         this.pickElement = false;
         this.removeObserver(elem);
         var id = 'tooltip_' + this.tagElement.id;
         this.labelObjectShow(this.tagElement.id, false);
         let buildModel = this.datauxview.getElementId(id);
         // this.dfx.modify(buildModel, { profile:'hidden' });
         this.tagElement = '';
         // this.pickElement =false;
       }
     }

  /***
   * tagElement added
   */
   observableTag(props) {
     var event = 'locate';
     if (props != '') {
       if (this.tagElement) {
         document.getElementById('tooltip_' + this.tagElement.id).style.display = "none";
         // this.onControlChange({event: 'locate',name:this.tagElement.id,state:false });
       }
       this.tagElement = props;
       if (this.selectEle) {
         if (this.selectEle == this.tagElement.id) {
           // this.pickElement = !this.pickElement;
           this.pickElement = true;
           if (this.pickElement) {
             // this.onControlChange({event: 'locate',name:this.tagElement.id,state:true });
           }
         } else {
           this.selectEle = this.tagElement.id;
           this.pickElement = true;
           // this.onControlChange({event: 'locate',name:this.tagElement.id,state:true });
         }
       } else {
         this.selectEle = this.tagElement.id;
         this.pickElement = true;
         // this.onControlChange({event: 'locate',name:this.tagElement.id,state:true });
       }
     }
   }
     labelObjectShow(element, flag) {
       let el = this.datauxview.getElementId(element);
       //console.log("el----- : ", el);
       if (el) {
         if (flag) {
           this.selectedLabel = element;
           // this.hideStaticObjTag(element)
           this.addObserver(el);
         } else {
           let dom = document.getElementById(element);
           if (dom) {
             dom.style.display = "none";
             delete this.selectedLabel;
             this.removeObserver(el);
           }
         }
       }
   
     }

     createLabelObject(shape, pos, uid) {
      var id = 'tooltip_' + uid;
      var elem = this.datauxview.getElementId(id);
      // var pos = e.pickedPoint;
      if (!elem) {
        var size = 0.0001;
        let profiles = { transparent: { material: 'transparent' }, regular: { material: 'hidden_obj' } };
        let settings = { 'geometry': { 'orientation': { x: 0, y: 0, z: 0 }, position: { x: pos.x, y: pos.y, z: pos.z }, size: size } };
        this.datauxview.addElement(shape, id, profiles, settings);
        let buildModel = this.datauxview.getElementId(id);
        let base = this.datauxview.getElementId(uid);
        let pmesh = this.dfx.getElementMesh(base);
        let cmesh = this.dfx.getElementMesh(buildModel);
        cmesh.setParent(pmesh);
        //this.dfx.modify(buildModel, { profile:'transparent' });
      }
      if (this.selectedLabel != id) {
        // if(this.selectedLabel){
        //   // this.labelObjectShow(id,false);
        //   // let buildModel = this.datauxview.getElementId(id);
        //   // this.dfx.modify(buildModel, { profile:'hidden' });
        // }else{
        let buildModel = this.datauxview.getElementId(id);
        //this.dfx.modify(buildModel, { profile:'transparent' });
        if (this.pickElement) {
          this.labelObjectShow(id, true)
        }
        // }
      }
    }
    /**
     * environment texture settings
     */
     processModel() {
      let app = this;
  
      this.scene.activeCamera._getViewMatrix = function () {
        var bp = 0;
        this.CalcPosition();
        this._computeViewMatrix(this.position, this.GetTargetPos(), this.upVector);
        return this._viewMatrix;
      };
      let hdrTexture = this.scene.environmentTexture;
      //hdrTexture.rotationY=-Math.PI
      app.scene.environmentBRDFTexture = null;
      for (let i = 0; i < app.scene.materials.length; i++) {
        let mtl = app.scene.materials[i];
        let mtl_clname = mtl.getClassName();
        if (mtl_clname === "PBRMaterial") {
          let pbr = mtl;
          pbr.albedoColor.r *= 1.28;
          pbr.albedoColor.g *= 1.28;
          pbr.albedoColor.b *= 1.28;
  
          if (pbr.metallic == 0) {
            pbr.roughness = 1; //model s/b fixed <---------------------------------------
  
          }
          //this is always 0 in Blender, but becomes 1 here
          pbr.specularIntensity = 0;
          //console.log("  specIntensity:" + pbr.specularIntensity + " forced to zero");
          //the master light switch
          //console.log("  envIntensity:" + pbr.environmentIntensity);
          //Babylon's clearcoat seems overly bright and washed out
          //so we turn it down half way
          if (pbr.clearCoat.isEnabled) {
            let orig = pbr.clearCoat.intensity;
            pbr.clearCoat.intensity *= 0.5;
            //console.log("  cc_Intensity:" + orig + " changed to " + pbr.clearCoat.intensity);
           // console.log("  cc_roughness:" + pbr.clearCoat.roughness);
          }
          else {
           // console.log("  cc disabled");
          }
          
        }
        else {
          //console.log("Mtl:" + mtl.name + " NOT PBR.");
        }
      }
    }


  /***
   * Animation scripts starts
   */
  showEngineAnimationModel(boo = true) {
    let engine = this.getMesh('iengine_animation');
    engine.setEnabled(boo);
  }

  getChildMeshEx(id, cid) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    let meshes = mesh.getChildMeshes();
    let idx = meshes.findIndex(e => this.getMeshName(e.name) === cid);
    if (idx > -1) {
      return meshes[idx];
    }
    return null;
  }

  initEngineAnim() {
    //this.initColorAnim();
    let engine = this.getMesh('iengine_animation');
    let scene = this.scene;
    scene.stopAllAnimations();
    // engine.setEnabled(false);
    // return
    let ag = scene.animationGroups;
    console.log(ag)
    ag.forEach((g) => {
      let norm = false;
      g.targetedAnimations.forEach((a) => {
        let n = a.target.name
        let nt = this.getChildMeshEx('iengine_animation', n);
        if (a.target.getClassName() === 'TransformNode' && !nt) {
          nt = this.getChildTransEx('iengine_animation', n);
        }
        a.target = nt;
        /* if (n.includes("_air_")) {
          norm = true;
          nt.material = this.dfx.getStandardMaterial("amat_" + n);
          nt.material.alpha = 0.4;

          if ((n === "cyl1_air_01") || (n === "cyl1_air_01.003")) {
            this.addColorAnim(g, nt, 1)
          } else {
            this.addColorAnim(g, nt, 2)
          }
        } */

      })
      if (norm) {
        this.debug_ag.push(g);
      }
      g.reset();
      //g.normalize(0, 13);
    })
    engine.scaling.z *= -1;
    /* let c1 = this.getChildMeshEx('iengine', 'intake');
    let c2 = this.getChildMeshEx('iengine', 'oil pan');
    let c3 = this.getChildMeshEx('iengine', 'air filter');
    let c4 = this.getChildMeshEx('iengine', 'exhaust');
    [c1, c2, c3, c4].forEach((m) => {
      m.mid = m.material.name;
    })
    let block = this.getChildMeshEx('iengine', 'block');
    let head = this.getChildMeshEx('iengine', 'head');
    let cover = this.getChildMeshEx('iengine', 'valve cover');
    block.isVisible = false;
    head.isVisible = false;
    cover.isVisible = false; */
    engine.setEnabled(false);
    this.engineTransToggle(false);
    this.excludeRHIBLighting(engine);
  }

  engineTransToggle(boo) {
    /* let c1 = this.getChildMeshEx('iengine', 'intake');
    let c2 = this.getChildMeshEx('iengine', 'oil pan');
    let c3 = this.getChildMeshEx('iengine', 'air filter');
    let c4 = this.getChildMeshEx('iengine', 'exhaust');
    let mat = this.scene.getMaterialByName('transparent');
    [c1, c2, c3, c4].forEach((m) => {
      if (boo) {
        mat = this.scene.getMaterialByName(m.mid);
      }
      m.material = mat;
    }) */
    //'exhaust'
  }

  aID
  smoke
  pemit
  startEngineAnim() {
    let target = { x: 0.07, y: 1.11, z: -0.0968 };
    let distance = 3.1;
    let yaw = -46
    let pitch = 1
    this.moveCameraTo(null, { target, distance, yaw, pitch });
    this.showEngineModel(false);
    this.showEngineAnimationModel();
    this.scene.animationGroups.forEach((anim) => {
      anim.play(true)
    })
    return;
    /* let c = 0
    let anim = (t) => {
      if (c % 60 === 0) {
        c = 0
        this.debug_ag.forEach((anim) => {
          anim.animatables.forEach((a) => {
            console.log(t, a.masterFrame)
          })
        })
      }
      c++;
      this.aID = requestAnimationFrame(anim);
    }
    requestAnimationFrame(anim); */
    if (!this.pemit) {
      let particleEmitter = BABYLON.MeshBuilder.CreateBox("particleEmitter", { size: 0.05 }, this.scene);
      particleEmitter.position = new BABYLON.Vector3(0.67, 0.97, 0.197);
      particleEmitter.rotation.x = BABYLON.Tools.ToRadians(90);
      particleEmitter.isVisible = false;
      this.pemit = particleEmitter;
    }

    let smoke = BABYLON.ParticleHelper.CreateAsync("smoke", this.scene).then((set) => {
      set.emitter = this.pemit;
      set.start(this.pemit);
      this.smoke = set;
      for (const sys of set.systems) {
        /* sys.emitter.x=0.67
        sys.emitter.y=0.96
        sys.emitter.z=0.197 */
        //sys.emitRate=10; 
        sys.minLifeTime = 1
        sys.maxLifeTime = 3;
        sys.emitRate = 3
        sys.gravity.z = 9;
        sys.blendMode = 4;
        /* sys.direction1 = new BABYLON.Vector3(0, 1, 1);
        sys.direction2 = new BABYLON.Vector3(0, -1, 1);
        sys.gravity = new BABYLON.Vector3(0, 0, 0.5); */
      }

    })

  }
  stopEngineAnim() {
    /* this.smoke.dispose();
    this.smoke = null; */
    cancelAnimationFrame(this.aID);
    this.scene.stopAllAnimations();
    this.showEngineAnimationModel(false);
    this.showEngineModel();
    this.changeCamView('home', false);
  }

}



